import { Divider, Typography, Grid } from "@material-ui/core";
import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";
import { getLeaderboard, updateHeaderInfo, copyDeck } from "../actions";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { deviceData, getThisYear, setActiveNavigationWidget, HOME_TEXT_ARRAY } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';

import { CopyrightWidget, LoadingCard } from "../components";

class LeaderBoard extends Component {
    state = {
        reload: false,
        selected: -1,
        boardname: 'Overall',
        main: [],
        tracking: null,
        loading: true,
        timespan: 'quarterly',
        loadingtext: 'Loading Leaderboard Data.',
    }

    randomtext = () => {
        const arr = HOME_TEXT_ARRAY;
    
        let cnt = 0;
    
        let interval = setInterval(() => {
            // const randomIndex = Math.floor(Math.random() * arr.length);
            let t = arr[cnt];
            this.setState({ ...this.state, loadingtext : t});
            cnt++;
        }, 1500, cnt);
    
        return this.setState({ ...this.state, interval: interval });
    }

    componentDidMount = async () => {
        setActiveNavigationWidget("homeFooterIcon");
        await this.props.updateHeaderInfo({
            route:"/leaderboard", 
            name: "Rankings", 
            iconTwo: 'menu',
            iconOne: 'home',
        });

        const { mcid, key } = this.props.auth_feedback;
        await this.props.getLeaderboard({
            mcid: mcid,
            key: key,
            tracking: deviceData(this.props.location, 'get leaderboard'),
            timespan: 'quarterly'
        });

        this.setState ({ ...this.state, tracking: deviceData(this.props.location, 'navigate'), loadingtext: this.randomtext()  })
        
        return null
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.leaderboard !== this.props.leaderboard) {
            this.setState({ ...this.state, main: this.props.leaderboard[0].mainLeaderboard, loading: false})
        }

        if (prevState.timespan !== this.state.timespan) {
            const { mcid, key } = this.props.auth_feedback;
            await this.setState({
                ...this.state,
                loading: true
            })
            
            return this.props.getLeaderboard({
                mcid: mcid,
                key: key,
                tracking: deviceData(this.props.location, 'get leaderboard'),
                timespan: this.state.timespan
            });

            
        }

        if (prevState.selected !== this.state.selected) {
        }

        if (this.state.reload) {
            this.setState({ ...this.state, reload: false});
        }
    }

    componentWillUnmount = () => {
        return window.removeEventListener('scroll', this.handleScroll);
    }

    setStateBoard = async (val) => {
        let temp, name;

        if (val == -1) {
            name = 'Overall';
            temp = this.props.leaderboard[0].mainLeaderboard;
        } else {
            let t = this.props.leaderboard[0].areaLeaderboard[val];
            name = t.areaDescription;
            temp = t.areaRanking;
        }

        this.setState({
            ...this.state,
            main: temp,
            boardname: name
        })
    }

    handleSelect = async (event) => {
        await this.setState({
            ...this.state,
            selected: event.target.value
        });

        this.setStateBoard(event.target.value);
    } 

    mapLeaderBoard = () => {
        if (
            Array.isArray(this.props.leaderboard) 
            && typeof this.props.leaderboard[0] !== 'undefined'
        ) {
            return this.props.leaderboard[0].areaLeaderboard.map((area, index) => {
                return (
                    <MenuItem value={index}>
                        {area.areaDescription}
                    </MenuItem>
                );
            });
        } else {
            return null;
        }
    }

    setContainer = (bool) => {
        return { padding: "0 16px", margin: "calc(env(safe-area-inset-top) + 56px) 0 64px", width: "calc(100% - 32px)", backgroundColor: "white" };

        if (bool) {
            if (isBrowser && !isElectron) {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 40px)", height: "calc(100vh - 160px)" };
            } else {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)" };
            }
            
        } else {
            if (isBrowser && !isElectron) {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 40px)", height: "calc(100vh - 160px)" };
            } else {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)" };
            }
        }
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="aua-overflow" style={this.setContainer(isBrowser)}>
                    <div className="aua-container" style={{paddingBottom:"64px", paddingTop: "0", width:"calc(100% - 0px)"}}>
                        <Typography className="homeDividerText" style={{left: "-16px"}}>Leaderboard</Typography>

                        <div style={{ padding: "8px 0"}} className="flex-row-between width100">
                            <FormControl style={{width: "100%"}}>
                                <Select
                                    labelId="leaderboard-simple-select-label"
                                    id="leaderboard-simple-select"
                                    value={this.state.selected}
                                    onChange={this.handleSelect}
                                    style={{fontSize: "0.8em", width: "100%"}}
                                >
                                    <MenuItem value={-1}>Overall</MenuItem>
                                    {this.mapLeaderBoard()}
                                </Select>
                            </FormControl>
                        </div>
                        
                        <Grid item xs={12} className="text-blue margin-bottom-12 margin-top-8">
                            {this.state.boardname}
                        </Grid>

                        <Grid item xs={12} className="">
                            <TableContainer component={Paper}>
                                <Table style={{width: "100%"}} aria-label="simple table">
                                    <TableHead>
                                        <TableRow key="SASPSubs">
                                            <TableCell align="left">Rank</TableCell>
                                            <TableCell align="left">Name</TableCell>
                                            <TableCell align="right">Score</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.main.map((row) => (
                                            <TableRow key={row.name}>
                                                <TableCell align="left">{row.rank}</TableCell>
                                                <TableCell align="left">{row.displayName}</TableCell>
                                                <TableCell align="right">{row.score}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    
                        <CopyrightWidget 
                            begin={2020}
                            year={getThisYear()}
                            textAlign={'center'}
                            className=" margin-top-16 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                </div>
            );
        } else {
            return <LoadingCard textarray={this.state.loadingtext} />
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, leaderboard } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        deckList,
        auth_feedback,
        user_details,
        leaderboard
    };
};

const LeaderBoardScreen = connect(mapStateToProps, { updateHeaderInfo, getLeaderboard, copyDeck })(
    LeaderBoard
);

export { LeaderBoardScreen };
